import NaeTableTd from './NaeTableTd'
import NaeTableTh from './NaeTableTh'
import NaeTableWithPaging from './NaeTableWithPaging'

export default { td: NaeTableTd, th: NaeTableTh, Td: NaeTableTd, Th: NaeTableTh, TableWithPaging: NaeTableWithPaging }
